import React from 'react';
import { formatDate, isWithinDays, isPast } from '../types/inventory';
import './ExpiryDateCell.css';

interface ExpiryDateCellProps {
  nextExpiry: string | null;
  onClick: () => void;
}

const ExpiryDateCell: React.FC<ExpiryDateCellProps> = ({ nextExpiry, onClick }) => {
  let className = 'expiry-cell';
  let displayText = '-';

  if (nextExpiry) {
    displayText = formatDate(nextExpiry);
    
    if (isPast(nextExpiry)) {
      className += ' expired';
    } else if (isWithinDays(nextExpiry, 30)) {
      className += ' expiring-soon';
    } else if (isWithinDays(nextExpiry, 90)) {
      className += ' warning';
    }
  }

  return (
    <div 
      className={className}
      onClick={onClick}
      title={nextExpiry ? `Click to manage expiry dates` : 'No expiry dates set - click to add'}
    >
      {displayText}
    </div>
  );
};

export default ExpiryDateCell;
